import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import type { PaymentExpectation } from "./types/payment-expectation.types";

interface Props {
  show: boolean;
  record: PaymentExpectation | null;
  onClose: () => void;
  onConfirm: (cancelReason: string) => Promise<void>;
  submitting?: boolean;
}

export default function CancelExpectationModal({
  show,
  record,
  onClose,
  onConfirm,
  submitting = false,
}: Props) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (show) setReason("");
  }, [show]);

  return (
    <Modal isOpen={show} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Cancel Collection</ModalHeader>
      <ModalBody>
        <p className="text-muted mb-3">
          Cancel collection{" "}
          <span className="fw-semibold">{record?.code}</span>? This cannot be
          undone.
        </p>
        <div className="mb-0">
          <Label className="form-label">Reason (optional)</Label>
          <Input
            type="textarea"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="e.g. Invoice written off"
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose} disabled={submitting}>
          Keep
        </Button>
        <Button
          color="danger"
          onClick={() => void onConfirm(reason)}
          disabled={submitting}
        >
          {submitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden />
              Cancelling…
            </>
          ) : (
            "Cancel collection"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
